import { SearchInput } from '@/shared/components/search-input';
import { DateRangePicker } from '@/shared/components/shadcn/date-range-picker/date-range-picker';
import { useSelectedSavedQuery } from '@/shared/hooks/use-selected-saved-query';
import { useSharedDateRange } from '@/shared/hooks/use-shared-date-range';
import { useAtomValue } from 'jotai';
import { sidebarStateAtom } from '../../chat/atoms/sidebar-state-atom';
import { PublicFilter } from '../../shared/public-filter/public-filter';
import { usePublicFilter } from '../../shared/public-filter/use-public-filter';

type Props = {
  hideDateRange?: boolean;
};

export const InsightFilterHeader = (props: Props) => {
  const sidebarState = useAtomValue(sidebarStateAtom);
  const { query: selectedQuery } = useSelectedSavedQuery();
  const { dateRangeState, setDateRange } = useSharedDateRange();
  const { filterValues, setFilterValues, publicFilter, onKeywordFilterChange } = usePublicFilter(
    selectedQuery.id,
  );
  return (
    <div className="bg-background border-b px-6 py-3">
      <div className="flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between">
        <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:gap-4">
          <SearchInput
            initialValue={publicFilter.keyword}
            placeholder="Search by keyword"
            className="h-10 w-50"
            onSubmit={onKeywordFilterChange}
            onClear={() => onKeywordFilterChange('')}
          />
        </div>

        {/* Right side - Filter and Export buttons */}
        <div className="flex flex-wrap items-center justify-end gap-2">
          {!props.hideDateRange && (
            <DateRangePicker
              value={dateRangeState}
              onChange={setDateRange}
              showDateRange={!sidebarState.isOpen}
            />
          )}
          <PublicFilter values={filterValues} onChange={setFilterValues} />
        </div>
      </div>
    </div>
  );
};
